(function (document, window) {
    var historyBackSelector = document.querySelector('#history-back');
    if (!!historyBackSelector) {
        historyBackSelector.addEventListener('click', function() {
            window.history.back()
        }, false);
    }
})(document, window);
